import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TuiSizeL, TuiSizeM, TuiSizeS } from '@taiga-ui/core';
import { ViewMode } from '@src/models';

@Component({
  selector: 'field-new-web-page',
  templateUrl: './field-new-web-page.component.html',
  styleUrls: ['./field-new-web-page.component.scss', '../styles/field-new-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldNewWebPageComponent {
  @Input() mode?: ViewMode = 'view';
  @Input() name?: string;
  @Input() value?: string | null;
  @Input() size: TuiSizeS | TuiSizeM | TuiSizeL = 'l';
}
